require('./modals/web-contact-success-modal.jade')

ContactCtrl = ($scope, $filter, $translate, $location, userInfo, flash, ContactService, $modal) ->
  $scope.contact =
    name: userInfo?.name
    email: userInfo?.email

  $scope.isSubmitting = false

  $scope.subjects = if /^ja/i.test $translate.preferredLanguage() then [
    "こんな機能がほしい"
    "バグをみつけた"
    "登録アカウント情報を変更したい"
    "課金について聞きたい"
    "退会方法について聞きたい"
    "その他"
  ]
  else [
    "I would like to leave feedback."
    "I'm having trouble with this site."
    "How can I change my account information?"
    "Other"
  ]

  $scope.send = ->
    $scope.isSubmitting = true
    ContactService.send($scope.contact).then (resp) ->
      $modal.open({
        size: 'lg'
        templateUrl: "contact/modals/web-contact-success-modal.jade"
        controller: 'ContactSuccessCtrl'
        backdrop: 'static',
        keyboard: false
      })
    .catch (data) ->
      flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isSubmitting = false

  $scope.cancel =  ->
    $location.path('/')

ContactCtrl.$inject = [
  '$scope'
  '$filter'
  '$translate'
  '$location'
  'userInfo'
  'flash'
  'ContactService'
  '$modal'
]

module.exports = ContactCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/contact/contact-controller.coffee